import clsx from "clsx";
import { motion } from "framer-motion";

import { ReactNode } from "react";

/**
 * 公共的内容容器
 *  header
 *  section
 *  footer
 */
interface Props {
	header?: ReactNode;
	footer?: ReactNode;
	children: ReactNode;
	className?: string;
	padding?: boolean;
	animation?: boolean;
}
export default function ContentContainer(props: Props) {
	return (
		<motion.div
			className={clsx("flex h-full w-full flex-col  mx-auto", props.padding ? "px-4.5" : "", props.className)}
			initial={{ opacity: props.animation ? 0 : 1 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: props.animation ? 0 : 1 }}
			transition={{ duration: 0.2 }}
		>
			<div className="flex-shrink-0">{props.header}</div>
			<div
				className={clsx(
					"flex-1 overflow-y-auto hidden-scroll-bar",
					props.animation && "rf-page-ani rf-page-ani-delay-2",
				)}
			>
				{props.children}
			</div>
			<div className={clsx("flex-shrink-0", props.animation && "rf-page-ani rf-page-ani-delay-3")}>{props.footer}</div>
		</motion.div>
	);
}
